module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABAklEQVRYR8XX4RGCMAyG4dRFDLqIIziCTKajOIILiJ8b4AKtB8gPQSRtE+A3x/u0x6XgaOXLrdwndQAzH4g2525hvgRw/bdIVQDz/kSOPnEiCgFAVSwCGMXbanhR8AygnkKo7MDveNOnErhfTHcgJ97AsnYgN54F0IgnA7TiSQDNeDRAOx4FsIiLAVZxEcAyLgMUOxC57dc0E0w46Sk7O4h4dcDwhOuXprQLszvQ9CzfAxHAEiEGWCGiABaIaIA2IgmgiUgGaCGyABqIbEAuQgUwiQihJvKF+Wd5P53HEzM88ajY9LN8+PD218xtun+B4I8AbosCpMdwf5/aOxAb7u9/A/TGsCEPr7B9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/left.png
// module id = ODDI
// module chunks = 1